import { Model, View } from '@lernetz/ts-lib';
import { Subscription } from '@lernetz/ts-lib/src/Signal';

import { PopupPage } from './PopupPage';
import { PopupContainer } from '../popup-container/PopupContainer';

import template from './PopupPageButtons.html';
import largeButtonTemplate from './LargeButton.html';
import smallButtonTemplate from './SmallButton.html';

export class PopupPageButtons extends Model {

    public readonly marginTop: string;
    public readonly marginBottom: string;
    public page: PopupPage;
    public pages: PopupPage[];

    public constructor(dto, private readonly popupContainer: PopupContainer) {
        super({ marginTop: '', marginBottom: '', page: null, pages: [], ...dto });
    }

    public showPage(page: PopupPage): void {
        const index = this.pages.indexOf(page);
        page.hasPrevious = index > 0;
        page.hasNext = index < this.pages.length - 1;
        this.popupContainer.show(page);
        const subscription = page.navigate.subscribe(what => {
            switch (what) {
                case 'close':
                    this.popupContainer.close();
                    subscription.unsubscribe();
                    break;
                case 'next':
                    this.showPage(this.pages[index + 1]);
                    break;
                case 'previous':
                    this.showPage(this.pages[index - 1]);
                    break;
            }
        });
    }
}

export class PopupPageButtonsView extends View<PopupPageButtons> {

    public constructor() {
        super({ template });

        this.registry.add('-large', () => new View({ template: largeButtonTemplate }));
        this.registry.add('-small', () => new View({ template: smallButtonTemplate }));
    }
}
